
import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const internationalDays = [
  {
    id: 1,
    name: {
      ar: "اليوم العالمي للتعليم",
      en: "International Day of Education"
    },
    date: {
      ar: "24 يناير",
      en: "January 24"
    },
    description: {
      ar: "يوم عالمي يحتفل بدور التعليم في تحقيق السلام والتنمية المستدامة",
      en: "A global day celebrating the role of education in achieving peace and sustainable development"
    }
  },
  {
    id: 2,
    name: {
      ar: "اليوم العالمي للمرأة",
      en: "International Women's Day"
    },
    date: {
      ar: "8 مارس",
      en: "March 8"
    },
    description: {
      ar: "يوم عالمي يحتفي بإنجازات المرأة ويدعو إلى المساواة بين الجنسين",
      en: "A global day celebrating women's achievements and calling for gender equality"
    }
  },
  {
    id: 3,
    name: {
      ar: "اليوم العالمي للصحة",
      en: "World Health Day"
    },
    date: {
      ar: "7 أبريل",
      en: "April 7"
    },
    description: {
      ar: "يوم عالمي يسلط الضوء على قضايا الصحة العالمية",
      en: "A global day highlighting global health issues"
    }
  },
  {
    id: 4,
    name: {
      ar: "اليوم العالمي للبيئة",
      en: "World Environment Day"
    },
    date: {
      ar: "5 يونيو",
      en: "June 5"
    },
    description: {
      ar: "يوم عالمي يشجع على حماية البيئة والتوعية البيئية",
      en: "A global day promoting environmental protection and awareness"
    }
  },
  {
    id: 5,
    name: {
      ar: "اليوم العالمي للشباب",
      en: "International Youth Day"
    },
    date: {
      ar: "12 أغسطس",
      en: "August 12"
    },
    description: {
      ar: "يوم عالمي يحتفل بدور الشباب في التنمية والتغيير الاجتماعي",
      en: "A global day celebrating youth's role in development and social change"
    }
  }
];

const InternationalDays = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <div className={`min-h-screen bg-background ${isRTL ? "rtl" : "ltr"}`}>
      <Navbar />
      <main className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">
          {isRTL ? "الأيام العالمية" : "International Days"}
        </h1>
        
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{isRTL ? "اليوم العالمي" : "International Day"}</TableHead>
                <TableHead>{isRTL ? "التاريخ" : "Date"}</TableHead>
                <TableHead>{isRTL ? "الوصف" : "Description"}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {internationalDays.map((day) => (
                <TableRow key={day.id}>
                  <TableCell className="font-medium">
                    {day.name[isRTL ? "ar" : "en"]}
                  </TableCell>
                  <TableCell>{day.date[isRTL ? "ar" : "en"]}</TableCell>
                  <TableCell>{day.description[isRTL ? "ar" : "en"]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </main>
    </div>
  );
};

export default InternationalDays;
